// extracted by mini-css-extract-plugin
export var grid = "_3-5";
export var layout = "_3-0";
export var leftColumn = "_3-1";
export var leftInner = "_3-2";
export var rightColumn = "_3-3";
export var rightInner = "_3-4";